module.exports = __webpack_public_path__ + "img/logo_bestgob.3c64bc48.png";